import { __assign } from 'tslib';
import React__default from 'react';
import classNames from 'classnames';
import { CartContext } from '../../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import { NvCheckbox } from '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../../constants/analytics.esm.js';
import '../../../modals/content/index.esm.js';
import '../../../modals/content/default_validation_error.esm.js';
import '../../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../../modals/postProcessingActions/processLocationValidationError.esm.js';
import { ExomeMetaTypeEnum } from '@invitae/stargate-ts-fetch';
import '../../../constants/api.esm.js';
import ExomeAddOnTooltip from './ExomeAddOnTooltip.esm.js';
import styles from './ExomeAddOnContainer.module.esm.js';

var ExomeAddOnContainer = function (_a) {
    var _b;
    var addOnTargets = _a.addOnTargets, type = _a.type;
    var _c = React__default.useContext(CartContext), configureExomeAddOn = _c.configureExomeAddOn, hasInvalidExomeAddOnConfiguration = _c.hasInvalidExomeAddOnConfiguration;
    var isEditable = React__default.useContext(CartSettingsContext).isEditable;
    React__default.useEffect(function configureProbandOnlyAddOnOnMount() {
        if (type === ExomeMetaTypeEnum.ProbandOnly && !addOnTargets.proband) {
            configureExomeAddOn(__assign(__assign({}, addOnTargets), { proband: true }));
        }
    }, [addOnTargets, type]);
    var getCheckbox = React__default.useCallback(function (key, customName) { return (React__default.createElement(NvCheckbox, { checked: !!addOnTargets[key], disabled: type === ExomeMetaTypeEnum.ProbandOnly && key === 'proband', id: key, key: "toggle-".concat(key, "-add-on-target"), label: "Include secondary findings for ".concat(customName || key), onChange: function () {
            var _a;
            return configureExomeAddOn(__assign(__assign({}, addOnTargets), (_a = {}, _a[key] = !addOnTargets[key], _a)));
        } })); }, [addOnTargets]);
    var checkboxes = React__default.useMemo(function () {
        var checkboxes = [getCheckbox('proband')];
        if (type === 'Duo') {
            checkboxes.push(getCheckbox('mother', 'parent'));
        }
        else if (type === 'Trio') {
            checkboxes.push(getCheckbox('mother'), getCheckbox('father'));
        }
        return checkboxes;
    }, [getCheckbox, type]);
    var summary = React__default.useMemo(function () {
        var targets = [];
        addOnTargets.proband && targets.push('proband');
        if (type === 'Duo') {
            addOnTargets.mother && targets.push('parent');
        }
        else if (type === 'Trio') {
            addOnTargets.mother && targets.push('mother');
            addOnTargets.father && targets.push('father');
        }
        if (targets.length === 0) {
            return null;
        }
        return "Include secondary findings for ".concat(targets.join(', ').replace(/, ([^,]*)$/, ' and $1'));
    }, [addOnTargets, type]);
    return (React__default.createElement("fieldset", { className: classNames(styles.root, (_b = {}, _b[styles.static] = !isEditable, _b)), "data-testid": "exome-add-on-container" },
        isEditable ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("legend", { className: styles.header },
                "Specify individuals to opt in for secondary findings ",
                React__default.createElement(ExomeAddOnTooltip, null)),
            React__default.createElement("div", { className: styles.checkboxes }, checkboxes))) : (summary),
        hasInvalidExomeAddOnConfiguration && (React__default.createElement("span", { className: styles.validationError }, "Please select one individual for secondary findings add-on."))));
};

export { ExomeAddOnContainer as default };
//# sourceMappingURL=ExomeAddOnContainer.esm.js.map
